import { FaArrowDown, FaArrowUp, FaMinus } from 'react-icons/fa';
import { Skeleton } from '../Kit/_index';

const BLOCK = 'LStudio__app_metric';

/*
    🔥 TARJETA DE MÉTRICA

    El ladrillo de cualquier dashboard: un número grande, su etiqueta,
    y opcionalmente cuánto cambió respecto del período anterior.

    ⚠️ POR QUÉ trendDirection Y NO SOLO EL SIGNO

    En "ventas", subir es bueno. En "cancelaciones" o "tiempo de
    respuesta", subir es MALO. Si el color saliera solo del signo, la
    mitad de tus métricas mentirían: un +18% de bajas se pintaría de
    verde.

      'up_is_good'    -> sube verde, baja rojo   (ventas, usuarios)
      'down_is_good'  -> sube rojo, baja verde   (bajas, demoras)
      'neutral'       -> siempre gris            (solo informa)

    ⚠️ EL SKELETON VA ADENTRO, NO AFUERA

    Si el padre eligiera entre <Skeleton/> y <MetricCard/>, la grilla
    saltaría al cargar porque las dos cosas no miden igual. Con
    isLoading la tarjeta conserva su caja y solo cambia el contenido.
*/

const TREND_ICON = {
    up: <FaArrowUp />,
    down: <FaArrowDown />,
    flat: <FaMinus />,
};

// 🔥 Traduce (valor, semántica) a un tono. null si no hay tendencia.
const onResolveTrendTone = (trend, direction) => {

    if (trend === null || trend === undefined) return null;

    if (direction === 'neutral' || trend === 0) return 'neutral';

    const IS_UP = trend > 0;

    if (direction === 'down_is_good') return IS_UP ? 'danger' : 'ok';

    return IS_UP ? 'ok' : 'danger';
};

const onResolveTrendShape = (trend) => {
    if (trend === null || trend === undefined) return null;
    if (trend === 0) return 'flat';
    return trend > 0 ? 'up' : 'down';
};

export const MetricCard = ({
    label,
    value,
    unit = null,
    icon = null,
    tone = 'accent',                 // neutral | accent | ok | warn | danger
    variant = 'surface',             // surface | outline | ghost
    size = 'md',                     // sm | md | lg
    trend = null,                    // 12.4 | -3 | 0 | null
    trendDirection = 'up_is_good',   // up_is_good | down_is_good | neutral
    trendLabel = 'vs. período anterior',
    footer = null,
    isLoading = false,
    onClick = null,
}) => {

    const TREND_TONE = onResolveTrendTone(trend, trendDirection);

    const TREND_SHAPE = onResolveTrendShape(trend);

    const IS_CLICKABLE = typeof onClick === 'function';

    /*
        🔥 Solo es <button> si realmente hace algo. Un div con onClick no
           se alcanza con teclado, y un button decorativo ensucia el
           tabulado de toda la pantalla.
    */
    const Tag = IS_CLICKABLE ? 'button' : 'div';

    return (
        <Tag
            type={IS_CLICKABLE ? 'button' : undefined}
            className={BLOCK}
            data-tone={tone}
            data-variant={variant}
            data-size={size}
            data-clickable={IS_CLICKABLE}
            onClick={IS_CLICKABLE ? onClick : undefined}
        >

            <div className={`${BLOCK}__head`}>

                <span className={`${BLOCK}__label`}>{label}</span>

                {icon && <span className={`${BLOCK}__icon`} aria-hidden="true">{icon}</span>}

            </div>

            {
                isLoading
                    ? <Skeleton variant="title" width="60%" height={size === 'lg' ? 38 : 28} />
                    : (
                        <p className={`${BLOCK}__value`}>
                            {value}
                            {unit && <span className={`${BLOCK}__unit`}>{unit}</span>}
                        </p>
                    )
            }

            {
                !isLoading && TREND_SHAPE && (
                    <div className={`${BLOCK}__trend`} data-tone={TREND_TONE}>

                        <span className={`${BLOCK}__trend_icon`} aria-hidden="true">
                            {TREND_ICON[TREND_SHAPE]}
                        </span>

                        <span className={`${BLOCK}__trend_value`}>
                            {trend > 0 ? '+' : ''}{trend}%
                        </span>

                        {trendLabel && <span className={`${BLOCK}__trend_label`}>{trendLabel}</span>}

                    </div>
                )
            }

            {footer && <div className={`${BLOCK}__footer`}>{footer}</div>}

        </Tag>
    );
};
